export default __webpack_public_path__ + "42e64a95aa5af5c6b60afa3185afaf75.png";